import {
  clearExploreCoursesScrollState,
  readExploreCoursesScrollState,
} from "../utils/exploreCoursesScrollRestore";
import useDashboardScrollRestore from "./useDashboardScrollRestore";

/**
 * Restores vertical scroll (and optional card anchor) when returning to Explore Courses.
 */
const useExploreCoursesScrollRestore = ({ isReady, activeCategoryKey }) =>
  useDashboardScrollRestore({
    isReady,
    restoreTrigger: activeCategoryKey,
    readScrollState: readExploreCoursesScrollState,
    clearScrollState: clearExploreCoursesScrollState,
  });

export default useExploreCoursesScrollRestore;
